"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceSelector = void 0;
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const utilities_1 = require("../utilities");
const BarLoader_1 = __importDefault(require("react-spinners/BarLoader"));
class PlaceSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Places: { State: "Loading" }
        };
    }
    render() {
        // Add /?showTemp=true to show the temporary folder
        const urlParams = new URLSearchParams(window.location.search);
        const showTempParam = urlParams.get('showTemp');
        const showTemp = this.props.ShowTemp || showTempParam;
        return this.state.Places.State === "Loaded"
            ? React.createElement("table", { className: "place-selector" },
                React.createElement("tbody", null, this.state.Places.Items
                    .filter(place => place.Name != "Temp" || showTemp)
                    .map(place => React.createElement("tr", { style: { cursor: "pointer" }, onClick: () => { this.props.SelectPlace(place); }, key: place.Name },
                    React.createElement("td", null,
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.getIcon(place), fixedWidth: true })),
                    React.createElement("td", null, place.Name)))))
            : this.state.Places.State === "Loading"
                ? React.createElement(React.Fragment, null,
                    React.createElement("span", null, "Loading places..."),
                    React.createElement(BarLoader_1.default, null))
                : null // Error
        ;
    }
    componentDidMount() {
        this.props.FileService.getPlaces().then(result => {
            this.setState({ Places: { State: "Loaded", Items: result } });
        }, error => {
            const message = `${error}`;
            this.setState({
                Places: { State: "Error", Message: message }
            });
            this.props.RaiseAlert(`Failed to load places: ${message}`);
        });
    }
    getIcon(place) {
        switch (place.PlaceType) {
            case "LocalDrive": return free_solid_svg_icons_1.faHdd;
            case "MyResources": return free_solid_svg_icons_1.faUser;
            case "OurResources": return free_solid_svg_icons_1.faUsers;
            case "Releases": return free_solid_svg_icons_1.faBoxOpen;
            case "MyArchive": return free_solid_svg_icons_1.faArchive;
            case "AllUsers": return free_solid_svg_icons_1.faAddressBook;
            case "AllOrganizations": return free_solid_svg_icons_1.faBuilding;
            default:
                if (!place.PlaceType) {
                    return free_solid_svg_icons_1.faFolder;
                }
                else {
                    return utilities_1.AssertNever(place.PlaceType, "PlaceType");
                }
        }
    }
}
exports.PlaceSelector = PlaceSelector;
//# sourceMappingURL=place-selector.js.map